const PUBLIC_PATH = {
  // Public
  ROOT: "/",
  LOGIN: "/login",
  SIGNUP: "/signup",                                    // SignupV2 main route
  SIGNUP_MEMBER: "/signup/member",
  SIGNUP_MEMBER_RESULT: "/signup/member-signup/result",
  SIGNUP_PENDING_APPROVAL: "/signup/pending",
  SIGNUP_WORKSPACE: "/signup/workspace",
  SIGNUP_WORKSPACE_SUCCESS: "/signup/workspace-success",
  TEMPORARY_SIGNUP: "/temporary-signup",                // Keep for email-invited buyers
  CHANGE_PASSWORD: "/change-password",
  FIND_PASSWORD: "/find-password",
  TERMS: "/terms",
  CONTACT_US: "/contact-us",
  CONTACT_US_SUCCESS: "/contact-us/success",
  NOT_FOUND: "/404",
  MAIN_PAGE: "/mainPage",
};

export default PUBLIC_PATH;
